import { CanActivateFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { STORAGE_ITEM } from "~models/enums/storage-item.enum";

export const AuthGuard: CanActivateFn = () => {
    const router = inject(Router);

    if (!localStorage.getItem(STORAGE_ITEM.TOKENS)?.includes("access")) {
        router.navigate(["/auth"]);
        return false;
    } else {
        return true;
    }
};
